module.exports = __webpack_public_path__ + "img/张良镇.c04053f1.png";